module.exports = __webpack_public_path__ + "img/input.7d05e0f8.svg";